<script>
// others
import { getSavedState } from '@src/utils/localStorage'
export default {
    computed: {
        locationDescription() {
            return getSavedState('auth.selectedLocation')
        },
    },
    methods: {
        changeLocation() {
            this.$router.push('/choose-location')
        },
    },
}
</script>

<template>
    <div class="location__info">
        <b-dropdown variant="outline" no-caret>
            <template v-slot:button-content>
                <div class="d-flex">
                    <div class="location__info-icon">
                        <svgicon
                            height="38"
                            width="38"
                            name="icon_location"
                            color="#ffffff"
                        />
                    </div>
                    <div class="location__info-text">
                        <span class="location__info-name"
                            ><strong>{{
                                locationDescription.tradingName
                            }}</strong></span
                        >
                        <span class="location__info-address"
                            >{{ locationDescription.city }} |
                            {{ locationDescription.state }}
                        </span>
                    </div>
                </div>
            </template>
            <b-dropdown-item
                id="logout"
                href="#"
                @click.prevent="changeLocation"
            >
                <div class="d-flex align-items-center">
                    <svgicon
                        class="mr-2"
                        name="icon_change"
                        height="20px"
                        width="20px"
                        color="#009db8"
                    />
                    {{ $t('Buttons.changeLocation') }}
                </div>
            </b-dropdown-item>
        </b-dropdown>
    </div>
</template>

<style lang="scss" scoped>
@import '@src/design/components/location-info.scss';
</style>
